import { IIntegerPrecisionService } from '@core/interfaces/integer-precision-service.interface';
import { Availability, MenuItem } from '@core/models';
import { MenuItemFactory } from './menu-item.factory';
import { MenuItemProcessingContext } from './interfaces';

export class MenuItemProcessor {
	constructor(private readonly factory: MenuItemFactory) {}

	processCatalog(
		items: MenuItem[],
		availabilities: Availability[],
		precisionService: IIntegerPrecisionService,
		now: Date,
		existingItems?: MenuItem[]
	): MenuItem[] {
		const initialContext: MenuItemProcessingContext = {
			items,
			availabilities,
			existingItems,
			precisionService,
			now,
		};

		const catalogContext = this.factory
			.createCatalogRules()
			.reduce((context, rule) => rule(context), initialContext);
			
		return catalogContext.items;
	}
}

export const menuItemProcessor = new MenuItemProcessor(new MenuItemFactory());
